import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs/modular/sortable.core.esm.js';
import { put } from '@rails/request.js'

export default class extends Controller {
  connect() {
    this.initializeSortable()
  }

  disconnect() {
    this.sortable.destroy()
  }

  initializeSortable() {
    const sortableList = this

    this.sortable = Sortable.create(this.element, {
      handle: ".js-drag-handle",
      animation: 100,
      easing: "cubic-bezier(1, 0, 0, 1)",
      dataIdAttr: "data-id",
      ghostClass: sortableList.data.get("ghostClass"),
      dragClass: sortableList.data.get("dragClass"),

      onSort: function (e) {
        const ids = this.toArray()
        if (sortableList.data.get("url")) {
          const params = new URLSearchParams()
          ids.forEach(id => params.append('sortable_ids[]', id))
          put(sortableList.data.get("url"), {
            body: params,
            contentType: "application/x-www-form-urlencoded"
          })
        } else {
          document.getElementById(sortableList.data.get("target")).value = ids
        }
      }
    });
  }
}
